// extracted by mini-css-extract-plugin
export default {"container":"style_container__bALjb","backgroundImg":"style_backgroundImg__-qWiH","titleBox":"style_titleBox__7T-KF"};